<template>
  <div class="profile-document">

    <div class="columns">
      <div class="column is-3">
        <h2 class="subtitle">Name</h2>
        <h1 class="title is-4">{{ doc.name }}</h1>
      </div>

      <div class="column is-3" v-if="doc.number">
        <h2 class="subtitle">Number / ID</h2>
        <h1 class="title is-4">{{ doc.number }}</h1>
      </div>

      <div class="column is-3" v-if="dateIssued">
        <h2 class="subtitle">Issued</h2>
        <h1 class="title is-4">{{ dateIssued }}</h1>
      </div>

      <div class="column is-3" v-if="dateIssued">
        <h2 class="subtitle">Expires</h2>
        <h1 class="title is-4">{{ dateExpire }}</h1>
      </div>
    </div>

    <div class="columns" v-if="doc.otherDetails && doc.otherDetails.length">
      <div class="column">
        <div v-for="(detail, index) in doc.otherDetails" :key="index">
          <b>{{ detail.key }}:</b> {{ key.value }}
        </div>
      </div>
    </div>

    <template v-if="doc.images">
      <div class="columns is-multiline" v-for="image in doc.images" :key="image.id">
        <div class="column is-half">
          <div class="box">
            <img style="width: 100%" :src="image.url">
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: 'ProfileDocument',
  props: ['doc'],
  computed: {
    dateIssued () {
      return this.doc.dateIssued ? this.formatDate(this.doc.dateIssued) : false
    },
    dateExpire () {
      return this.doc.dateExpire ? this.formatDate(this.doc.dateExpire) : false
    }
  },
  methods: {
    formatDate (unixTimestamp) {
      return this.$moment.unix(unixTimestamp).format('DD/MM/YYYY')
    }
  }
}
</script>
